import { mixed, object, string } from "yup";

const createReportValues = {
  feeTypeValue: "fee",
  leaseTypeValue: "lease",
  allUserValue: "ALL",
  allMonthValue: "ALL",
};

const reportTypeEnum = [
  createReportValues.feeTypeValue,
  createReportValues.leaseTypeValue,
];

const createReportSchema = object().shape({
  type: mixed()
    .oneOf(reportTypeEnum, "無效的報表類別")
    .required("必須填寫報表類別"),
  user: string().required("必須填寫報表對象"),
  year: string().required("必須填寫年份"),
  month: string().required("必須填寫月份"),
});

export { createReportSchema, createReportValues };
